// src/pages/Achats/components/AchatsFiltersBar.jsx
import React from "react";
import { FaDownload, FaFilter, FaSearch, FaTimes } from "react-icons/fa";

const INPUT =
  "w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-100 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:border-indigo-500 dark:focus:ring-indigo-950";

export default function AchatsFiltersBar({
  q,
  setQ,
  formule,
  setFormule,
  formuleOptions,
  paidOnly,
  setPaidOnly,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
  sort,
  setSort,
  onExport,
  onResetFilters,
}) {
  return (
    <section className="rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900 sm:p-5">
      <div className="mb-4 flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-indigo-50 px-3 py-1 text-xs font-bold uppercase tracking-wide text-indigo-700 dark:bg-indigo-950/70 dark:text-indigo-300">
            <FaFilter />
            Filtres
          </div>

          <h2 className="mt-2 text-xl font-bold text-slate-900 dark:text-white">
            Rechercher un achat
          </h2>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={onExport}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-indigo-600 px-4 py-2.5 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-indigo-700"
          >
            <FaDownload />
            Export CSV
          </button>

          <button
            type="button"
            onClick={onResetFilters}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-100 px-4 py-2.5 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
          >
            <FaTimes />
            Réinitialiser
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 xl:grid-cols-12">
        <div className="relative xl:col-span-4">
          <FaSearch className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
          <input
            type="search"
            value={q}
            onChange={(event) => setQ(event.target.value)}
            placeholder="Nom, email, formule, statut..."
            className={`${INPUT} pl-11`}
          />
        </div>

        <select
          value={formule}
          onChange={(event) => setFormule(event.target.value)}
          className={`${INPUT} xl:col-span-2`}
        >
          {formuleOptions.map((option) => (
            <option key={option} value={option}>
              {option === "all" ? "Toutes formules" : option}
            </option>
          ))}
        </select>

        <select
          value={sort}
          onChange={(event) => setSort(event.target.value)}
          className={`${INPUT} xl:col-span-2`}
        >
          <option value="date_desc">Plus récents</option>
          <option value="date_asc">Plus anciens</option>
          <option value="amount_desc">Montant décroissant</option>
          <option value="amount_asc">Montant croissant</option>
          <option value="name_az">Nom A → Z</option>
          <option value="name_za">Nom Z → A</option>
        </select>

        <input
          type="date"
          value={dateFrom}
          onChange={(event) => setDateFrom(event.target.value)}
          className={`${INPUT} xl:col-span-2`}
        />

        <input
          type="date"
          value={dateTo}
          onChange={(event) => setDateTo(event.target.value)}
          className={`${INPUT} xl:col-span-2`}
        />
      </div>

      {/* <div className="mt-4 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={() => setPaidOnly(!paidOnly)}
          className={`inline-flex items-center gap-3 rounded-2xl px-4 py-2.5 text-sm font-bold transition ${
            paidOnly
              ? "bg-emerald-600 text-white hover:bg-emerald-700"
              : "bg-slate-100 text-slate-700 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
          }`}
        >
          <span
            className={`flex h-5 w-9 items-center rounded-full p-0.5 transition ${
              paidOnly ? "bg-white/30" : "bg-slate-300 dark:bg-slate-700"
            }`}
          >
            <span
              className={`h-4 w-4 rounded-full bg-white shadow transition ${
                paidOnly ? "translate-x-4" : "translate-x-0"
              }`}
            />
          </span>
          Payés uniquement
        </button>
      </div> */}
    </section>
  );
}
